import Echo from 'laravel-echo';
import {BROADCAST_CONNECT, BROADCAST_CONNECTED, BROADCAST_DISCONNECTED} from '@/store/actions';

const EchoPlugin = {
    install(Vue, { store }) {
        if (!store) {
            throw new Error('Please provide vuex store.');
        }

        window.io = require('socket.io-client');

        const access_token = localStorage.getItem('access-token');

        // Initialize Echo instance test
        console.log('Initializing Echo instance...');
        const EchoInstance = new Echo({
            broadcaster: 'socket.io',
            host: process.env.VUE_APP_ECHO_HOST || (process.env.VUE_APP_API_HOST + ':6001'),
            namespace: 'GoldExchange.Events',
            auth: {
                headers: {
                    Authorization: 'Bearer ' + access_token,
                },
            },
            reconnectionAttempts: 3,
            reconnectionDelay: 3000,
        });

        console.log('Registering socket event listeners...');

        // register socket event listeners
        EchoInstance.connector.socket.on('connect', () => {
            console.log('CONNECTED via Plugin.');
            console.log('Socket connected @ on{connect} event: ', EchoInstance.connector.socket.connected, EchoInstance.connector.socket.id);
            const h = vm.$createElement;
            const vNodesMsg = h(
                'div',
                { class: 'd-flex align-items-center' },
                [
                    h('div',
                        { class: 'mr-2' },
                        [
                            h('i', { class: 'fa-duotone fa-signal-stream fa-fw fa-2x fa-pull-left text-success' }, ''),
                        ]
                    ),
                    h('div',
                        [
                            h('strong', 'Notification server connected.'),
                            h('div', { class: 'font-xs' }, 'ID: ' + EchoInstance.connector.socket.id)
                        ]
                    ),
                ],
            );
            vm.$bvToast.toast([vNodesMsg], {
                variant: 'secondary',
                toaster: 'b-toaster-bottom-right',
                noCloseButton: true,
            });
            store.commit(BROADCAST_CONNECTED);
        });

        EchoInstance.connector.socket.on('connect_error', (error) => {
            console.log(error);
            const h = vm.$createElement;
            const vNodesMsg = h(
                'div',
                { class: 'd-flex align-items-center' },
                [
                    h('div',
                        { class: 'mr-2' },
                        [
                            h('i', { class: 'fa-duotone fa-bell-slash fa-fw fa-2x fa-pull-left text-danger' }, ''),
                        ]
                    ),
                    h('div',
                        [
                            h('strong', 'Could not connect to notification server.'),
                            h('div', { class: 'font-xs', style: 'text-transform: capitalize;' }, `${error}`)
                        ]
                    ),
                ],
            );
            vm.$bvToast.toast([vNodesMsg], {
                variant: 'secondary',
                toaster: 'b-toaster-bottom-right',
                noCloseButton: true,
            });
        });

        EchoInstance.connector.socket.on('disconnect', (reason) => {
            console.log('socket disconnect', reason);
            const h = vm.$createElement;
            const vNodesMsg = h(
                'div',
                { class: 'd-flex align-items-center' },
                [
                    h('div',
                        { class: 'mr-2' },
                        [
                            h('i', { class: 'fa-duotone fa-bell-slash fa-fw fa-2x fa-pull-left text-warning' }, ''),
                        ]
                    ),
                    h('div',
                        [
                            h('strong', 'Socket Disconnected.'),
                            h('div', { class: 'font-xs ', style: 'text-transform: capitalize;' }, reason)
                        ]
                    ),
                ],
            );
            vm.$bvToast.toast([vNodesMsg], {
                variant: 'secondary',
                toaster: 'b-toaster-bottom-right',
                noCloseButton: true,
            });
            store.commit(BROADCAST_DISCONNECTED);
        });

        Vue.prototype.$echo = EchoInstance;
    }
};

export default EchoPlugin;
